// extracted by mini-css-extract-plugin
module.exports = {"bold":"ob_s49QJ3","italic":"ob_qwzqf5","hidden":"ob_9kBIR8"};